export const MAX_STAGE_PERCENT_TOTAL = 100;

export function finitePercent(value, fallback = 0) {
  const n = Number(value);
  return Number.isFinite(n) ? n : fallback;
}

export function mergedStagePercentTotal(existing = [], incoming = []) {
  const byName = new Map();
  for (const row of existing) {
    const key = String(row?.name ?? '')
      .trim()
      .toLowerCase();
    if (!key) continue;
    byName.set(key, finitePercent(row.percentage));
  }
  for (const row of incoming) {
    const key = String(row?.name ?? '')
      .trim()
      .toLowerCase();
    if (!key) continue;
    byName.set(key, finitePercent(row.percentage));
  }
  let total = 0;
  for (const pct of byName.values()) total += pct;
  return { total, exceeds: total > MAX_STAGE_PERCENT_TOTAL };
}

export function stagePercentCapMessage(total) {
  const rounded = Math.round(total * 100) / 100;
  return `Payment stages cannot exceed ${MAX_STAGE_PERCENT_TOTAL}% (this would be ${rounded}%).`;
}

export function isAdvanceStageName(name) {
  return String(name ?? '')
    .trim()
    .toLowerCase() === 'advance';
}

export function reservedAdvanceRenameMessage() {
  return 'The Advance stage name cannot be changed.';
}

export function reservedAdvanceDeleteMessage() {
  return 'The Advance stage cannot be deleted.';
}
